// Shared by the broker's Documentation menu and the website's documentation pages.
export const documentationPages = [
    {id: "index", label: "Index", path: "/xmq_documentation",
        title: "XMQ MQTT Server Documentation",
        description: "Installation, configuration, testing, and setting up an XMQ cluster.", anchors: []},
    {id: "install", label: "Install", path: "/xmq_doc_install",
        title: "Download and Install",
        description: "Supported systems, packages, dependencies and host tuning.",
        anchors: ["supported-oses", "install", "tuning"]},
    {id: "setup", label: "Setup", path: "/xmq_doc_setup",
        title: "Basic and Advanced Setup",
        description: "Listeners, TLS, persistence, authentication, bridges, logging and limits.",
        anchors: ["basic-setup", "advanced-setup"]},
    {id: "testing", label: "Testing", path: "/xmq_doc_testing",
        title: "MQTT Test Suite and Smoke Tests",
        description: "The built-in scenario engine, and proving a new installation.",
        anchors: ["testing-suite", "testing-setup"]},
    {id: "permissions", label: "Permissions", path: "/xmq_doc_permissions",
        title: "Topic Permissions",
        description: "Rules for who may publish or subscribe to what, importing Mosquitto ACLs, and the known limitations.",
        anchors: ["permissions", "permissions-import", "permissions-csv", "permissions-limitations"]},
    {id: "mosquitto-import", label: "Mosquitto Import", path: "/xmq_doc_mosquitto_import",
        title: "Importing from Mosquitto",
        description: "Moving Mosquitto accounts and ACL rules across: password files, ACL files, dynamic security, conflicts and limitations.",
        anchors: ["mosquitto-import", "mosquitto-import-files", "mosquitto-import-plan",
                  "mosquitto-import-passwords", "mosquitto-import-acl", "mosquitto-import-dynsec",
                  "mosquitto-import-csv", "mosquitto-import-limitations"]},
    {id: "data-integration", label: "Data Integration", path: "/xmq_doc_data_integration",
        title: "Data Integration",
        description: "Posting accepted MQTT messages and broker log records to HTTP(S) endpoints: sources, settings, and what it costs.",
        anchors: ["data-integration", "data-integration-enable", "data-integration-sources",
                  "data-integration-payload", "data-integration-settings",
                  "data-integration-destinations", "data-integration-performance",
                  "data-integration-security", "data-integration-delivery"]},
    {id: "cluster", label: "Cluster", path: "/xmq_doc_cluster",
        title: "Setting up a Cluster",
        description: "Shared accounts and Redis, node certificates, and joining a cluster.",
        anchors: ["cluster-setup"]},
    {id: "sizing", label: "Sizing", path: "/xmq_doc_sizing",
        title: "Sizing a Broker, and What a Restart Costs",
        description: "What a session may hold, what a restart of many clients costs, and why a load balancer is not needed.",
        anchors: ["session-limits", "latency-and-throughput", "restart", "reconnects", "clusters"]},
    {id: "load-balancer", label: "Load Balancer", path: "/xmq_doc_load_balancer",
        title: "A Load Balancer in Front of a Cluster",
        description: "IPVS and HAProxy in front of an XMQ cluster, without session affinity.",
        anchors: ["load-balancer"]}
];

export function documentationPage(id) {
    return documentationPages.find(page => page.id === id);
}
